import classNames from "classnames";
import React, { useContext, useEffect, useState } from "react";
import { useCabineContext } from "../../../context/CabineContext";
import Axios from "../../../_services/caller.service";
import styles from "./UpdateFeatures.module.scss";
import { GiMushroomCloud, GiOverkill } from "react-icons/gi";

import Modal from "../../UiComponents/modals/Modal";
import useModal from "../../../hooks/useModal";
import InputForms from "../../UiComponents/forms/InputForms";
import Button from "../../UiComponents/Button";
import InputPassword from "../../UiComponents/forms/InputPassword";
import { toast } from "react-toastify";

import { use } from "react";
import NavContext from "../../../context/NavContext";
import { PermissionGate } from "../managePermissions/PermissionGate";

const UpdateFeatures = ({
  cabId,
  majCabine,
  setMajCabine,
  levelLog,
  changeLevelLog,
}) => {
  const { cabine } = useCabineContext(); //all cabine owner
  const { ownerProfile, realOwnerProfile, setRealOwnerProfile } =
    useContext(NavContext);
  const [updateNextStart, setUpdateNextStart] = useState(false);
  const [forceRepairOnQuit, setForceRepairOnQuit] = useState(false);
  const [showBridge, setShowBridge] = useState(false);
  const [DeleteDiracLicence, setDiracDeleteLicense] = useState(false);
  const [showDetector, setShowDetector] = useState(false);
  const [allowDebugPath, setAllowDebugPath] = useState(false);
  const [killSwitch, setKillSwitch] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);

  const { isShowing, toggle } = useModal();

  //KILL SWITCH
  const [passwordAdmin, setPassWordAdmin] = useState("");

  const [showFunctionAtomic, setShowFunctionAtomic] = useState(false);

  //CONTROLLER
  const controller = new AbortController();
  const signal = controller.signal;

  // GET UPDATE NEXT START
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/UpdateNextStart/${cabId}`, { signal })

        .then(function async(response) {
          if (response.data.message === "UpdateNextStart none") {
            setUpdateNextStart(false);
            return;
          } else {
            const data = response.data.data[0].fval;

            if (data === "1") {
              setUpdateNextStart(true);
            } else {
              setUpdateNextStart(false);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
      return () => {
        controller.abort();
      };
    }
  }, [cabId, cabine, majCabine]);

  // GET FORCE REPAIR ON QUIT
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/ForceRepairOnQuit/${cabId}`, { signal })

        .then(function async(response) {
          if (response.data.message === "ForceRepairOnQuit none") {
            setForceRepairOnQuit(false);
            return;
          } else {
            const data = response.data.data[0].fval;

            if (data === "1") {
              setForceRepairOnQuit(true);
            } else {
              setForceRepairOnQuit(false);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
      return () => {
        controller.abort();
      };
    }
  }, [cabId, cabine, majCabine]);

  // GET SHOW BRIDGE
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/ShowBridge/${cabId}`, { signal })

        .then(function async(response) {
          if (response.data.message === "ShowBridge none") {
            setShowBridge(false);
            return;
          } else {
            const data = response.data.data[0].fval;

            if (data === "1") {
              setShowBridge(true);
            } else {
              setShowBridge(false);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
      return () => {
        controller.abort();
      };
    }
  }, [cabId, cabine, majCabine]);

  // GET SHOW DECTECTOR
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/ShowDetector/${cabId}`, { signal })

        .then(function async(response) {
          if (response.data.message === "ShowDetector none") {
            setShowDetector(false);
            return;
          } else {
            const data = response.data.data[0].fval;

            if (data === "1") {
              setShowDetector(true);
            } else {
              setShowDetector(false);
            }
          }
        })
        .catch(function (error) {
          //  console.log(error);
        });
      return () => {
        controller.abort();
      };
    }
  }, [cabId, cabine, majCabine]);
  // GET ALLOW DEBUG PATH
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/AllowDebugPath/${cabId}`, { signal })

        .then(function async(response) {
          if (response.data.message === "AllowDebugPath none") {
            setAllowDebugPath(false);
            return;
          } else {
            const data = response.data.data[0].fval;

            if (data === "1") {
              setAllowDebugPath(true);
            } else {
              setAllowDebugPath(false);
            }
          }
        })
        .catch(function (error) {
          //  console.log(error);
        });
      return () => {
        controller.abort();
      };
    }
  }, [cabId, cabine, majCabine]);
  // GET DELETE DIRAC LICENCE
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/DeleteDiracLicence/${cabId}`, { signal })

        .then(function async(response) {
          if (response.data.message === "DeleteDiracLicence none") {
            setDiracDeleteLicense(false);
            return;
          } else {
            const data = response.data.data[0].fval;

            if (data === "1") {
              setDiracDeleteLicense(true);
            } else {
              setDiracDeleteLicense(false);
            }
          }
        })
        .catch(function (error) {
          //  console.log(error);
        });
      return () => {
        controller.abort();
      };
    }
  }, [cabId, cabine, majCabine]);

  // GET KILLSWITCH
  useEffect(() => {
    if (cabine !== "") {
      Axios.get(`/KillSwitch/${cabId}`, { signal })

        .then(function async(response) {
          if (response.data.message === "KillSwitch none") {
            setKillSwitch(false);

            return;
          } else {
            const data = response.data.data[0].fval;

            if (data === "1") {
              setKillSwitch(true);
            } else {
              setKillSwitch(false);
            }
          }
        })
        .catch(function (error) {
          //  console.log(error);
        });
      return () => {
        controller.abort();
      };
    }
  }, [cabId, cabine, majCabine]);

  //UPDATE NEXT CALIB
  const setUpdateNextStartInDb = (checked) => {
    Axios.post(`/createCatidApplicationData/${cabId}`)

      .then((response) => {
        if (checked) {
          Axios.put(`/setUpdateNextStart/${cabId}`, {
            data: "1",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setUpdateNextStart(true);
              } else {
                setUpdateNextStart(false);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          Axios.put(`/setUpdateNextStart/${cabId}`, {
            data: "0",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setUpdateNextStart(true);
              } else {
                setUpdateNextStart(false);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      })
      .catch((error) => {});
  };
  //FORCE REPAIR ON QUIT
  const setForceRepairOnQuitInDb = (checked) => {
    Axios.post(`/createCatidApplicationData/${cabId}`)

      .then((response) => {
        if (checked) {
          Axios.put(`/setForceRepairOnQuit/${cabId}`, {
            data: "1",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setForceRepairOnQuit(true);
              } else {
                setForceRepairOnQuit(false);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          Axios.put(`/setForceRepairOnQuit/${cabId}`, {
            data: "0",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setForceRepairOnQuit(true);
              } else {
                setForceRepairOnQuit(false);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      })
      .catch((error) => {});
  };

  const setShowBridgeInDb = (checked) => {
    Axios.post(`/createCatidApplicationData/${cabId}`)

      .then((response) => {
        if (checked) {
          Axios.put(`/setShowBridge/${cabId}`, {
            data: "1",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setShowBridge(true);
              } else {
                setShowBridge(false);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          Axios.put(`/setShowBridge/${cabId}`, {
            data: "0",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setShowBridge(true);
              } else {
                setShowBridge(false);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      })
      .catch((error) => {});
  };
  const setShowDetectorInDb = (checked) => {
    Axios.post(`/createCatidApplicationData/${cabId}`)

      .then((response) => {
        if (checked) {
          Axios.put(`/setShowDetector/${cabId}`, {
            data: "1",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setShowDetector(true);
              } else {
                setShowDetector(false);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          Axios.put(`/setShowDetector/${cabId}`, {
            data: "0",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setShowDetector(true);
              } else {
                setShowDetector(false);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      })
      .catch((error) => {});
  };

  //SET ALLOW DEBUG PATH
  const setAllowDebugPathInDb = (checked) => {
    Axios.post(`/createCatidApplicationData/${cabId}`)

      .then((response) => {
        if (checked) {
          Axios.put(`/setAllowDebugPath/${cabId}`, {
            data: "1",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setAllowDebugPath(true);
              } else {
                setAllowDebugPath(false);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          Axios.put(`/setAllowDebugPath/${cabId}`, {
            data: "0",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setAllowDebugPath(true);
              } else {
                setAllowDebugPath(false);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      })
      .catch((error) => {});
  };

  //SET DELETE DIRAC LICENCE
  const setDeleteDiracLicenceInDb = (checked) => {
    Axios.post(`/createCatidApplicationData/${cabId}`)

      .then((response) => {
        if (checked) {
          Axios.put(`/setDeleteDiracLicence/${cabId}`, {
            data: "1",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setDiracDeleteLicense(true);
              } else {
                setDiracDeleteLicense(false);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          Axios.put(`/setDeleteDiracLicence/${cabId}`, {
            data: "0",
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              if (data === "1") {
                setDiracDeleteLicense(true);
              } else {
                setDiracDeleteLicense(false);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      })
      .catch((error) => {});
  };

  //SET KILL SWITCH
  const setKillSwitchUpdateInDb = (checked) => {
    Axios.post(`/createCatidApplicationData/${cabId}`)

      .then((response) => {
        if (checked) {
          Axios.put(`/setKillSwitch/${cabId}`, {
            data: "1",
            passwordAdmin: passwordAdmin,
            admin: realOwnerProfile.ID,
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              toast.success("KillSwitch activé");

              if (data === "1") {
                setKillSwitch(true);
                setHasChanged(true);
              } else {
                setKillSwitch(false);
                setHasChanged(true);
              }
            })
            .catch(function (error) {
              toast.error(error.response.data.msg);
            });
        } else {
          Axios.put(`/setKillSwitch/${cabId}`, {
            data: "0",
            passwordAdmin: passwordAdmin,
            admin: realOwnerProfile.ID,
          })

            .then((response) => {
              const data = response.data.data[0].fval;

              toast.success("KillSwitch désactivé");

              if (data === "1") {
                setKillSwitch(true);
                setHasChanged(true);
              } else {
                setKillSwitch(false);
                setHasChanged(true);
              }
            })
            .catch(function (error) {
              toast.error(error.response.data.msg);
            });
        }
      })
      .catch((error) => {});
  };

  /* ATOMIC ZONE FONCTION QUI VERIFIE LES MOTS DE PASSE AVANT D'AFFICHER Les Fonctions protégés*/

  const authFunctionAtomic = () => {
    Axios.post(`/authFunctionAtomic/${cabId}`, {
      passwordAdmin: passwordAdmin,
      admin: realOwnerProfile.ID,
    })
      .then((response) => {
        if (response.data.isVerified) {
          setShowFunctionAtomic(true);
          toast.success("Accès autorisé");
        } else {
          toast.error(response.data.msg);
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la vérification", error);
        toast.error("Erreur lors de la vérification");
      });
  };

  const closeModal = () => {
    toggle();
    setPassWordAdmin("");

    setShowFunctionAtomic(false);
  };

  const handleCabineDelete = async () => {
    const confirmed = window.confirm(
      "Êtes-vous sûr de vouloir supprimer définitivement cette cabine ? Cette action est irréversible."
    );
  
    if (!confirmed) return;
  
    try {
      const { data } = await Axios.delete(`/deleteCabine/${cabId}`, {
        data: {
          passwordAdmin: passwordAdmin,
          admin: realOwnerProfile.ID,
        },
      });
  
      if (data?.error) {
        toast.error("Erreur lors de la suppression de la cabine : " + data.error);
        return;
      }
  
      toast.success("Cabine supprimée avec succès");
  
      // Fermer la modale si tu as une fonction comme closeModal()
      if (typeof closeModal === "function") {
        closeModal();
      }
  
      // Recharger la page après un petit délai
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      
    } catch (error) {
      console.error("Erreur suppression cabine :", error);
      toast.error("Erreur lors de la suppression de la cabine : " + error.message);
    }
  };
  
  return (
    <div className={styles.settingsFeatures}>
      <div className={styles.container}>
        <div className={styles.optional}>
          <h3>Debug :</h3>
          <div className={styles.name}>
            <span>ForceRepairOnQuit</span>

            <div
              // get cabId and User ID
              className={styles.containerCheckBox}
            >
              <PermissionGate actionKey="cabines.debugPath">
              <input
                type="checkbox"
                onChange={(e) => setForceRepairOnQuitInDb(e.target.checked)}
                checked={forceRepairOnQuit}
              /></PermissionGate>
              <label></label>
            </div>
          </div>
          <div className={styles.name}>
            <span>AskUpdate</span>

            <div
              // get cabId and User ID
              className={styles.containerCheckBox}
            >    
             <PermissionGate actionKey="cabines.debugPath">
              <input
                type="checkbox"
                onChange={(e) => setUpdateNextStartInDb(e.target.checked)}
                checked={updateNextStart}
              /></PermissionGate>
              <label></label>
            </div>
          </div>
          <div className={styles.name}>
            <span>ShowBridge</span>
            <div className={styles.containerCheckBox}>
               <PermissionGate actionKey="cabines.debugPath">
              <input
                type="checkbox"
                onChange={(e) => setShowBridgeInDb(e.target.checked)}
                checked={showBridge}
              /></PermissionGate>
              <label></label>
            </div>
          </div>
          <div className={styles.name}>
            <span>ShowDetector</span>

            <div className={styles.containerCheckBox}>
               <PermissionGate actionKey="cabines.debugPath">
              <input
                type="checkbox"
                onChange={(e) => setShowDetectorInDb(e.target.checked)}
                checked={showDetector}
              /></PermissionGate>
              <label></label>
            </div>
          </div>
          <div className={styles.name}>
            <span>AllowDebugPath</span>

            <div className={styles.containerCheckBox}>
               <PermissionGate actionKey="cabines.debugPath">
              <input
                type="checkbox"
                onChange={(e) => setAllowDebugPathInDb(e.target.checked)}
                checked={allowDebugPath}
              /></PermissionGate>
              <label></label>
            </div>
          </div>{" "}
          <div className={styles.name}>
            <span>DeleteDiracLicense</span>

            <div className={styles.containerCheckBox}>
               <PermissionGate actionKey="cabines.debugPath">
              <input
                type="checkbox"
                onChange={(e) => setDeleteDiracLicenceInDb(e.target.checked)}
                checked={DeleteDiracLicence}
              /></PermissionGate>
              <label></label>
            </div>
          </div>{" "}
          <div>
            {cabine && (
              <div className={styles.setLogging}>
                <span>set Logging Level</span>
                  <PermissionGate actionKey="cabines.setLoggingLevel">
                <select
                  // value={sortedLevelLogging(cabId)}
                  value={levelLog}
                  onChange={(e) => changeLevelLog(e)}
                  name=""
                  id=""
                >
                  <option value="0">None</option>
                  <option value="1">Standard</option>
                  <option value="2">Critical</option>
                  <option value="3">Full</option>
                </select>
                </PermissionGate>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={styles.containerKillSwitchButton}>
        <div className={styles.tooltipWrapper}>
          <PermissionGate actionKey="cabines.protectedFunctions">
          <GiMushroomCloud
            className={styles.killSwitchBtn}
            style={{
              cursor: "pointer",
              fontSize: "45px",
            }}
            onClick={toggle}
          /></PermissionGate>
          <div className={styles.tooltipCard}>
            Fonctions protégées
            <br />
            (KillSwitch et suppression de la cabine)
          </div>
        </div>
      </div>

      {/* MODAL KILLSWITCH */}
      <Modal isShowing={isShowing} hide={closeModal}>
        {!showFunctionAtomic ? (
          <div className={styles.containerModal}>
            <div className={styles.avertissement}>
              <GiMushroomCloud
                title="Fonctions protégées (KillSwitch et suppression de la cabine)"
                style={{
                  color: "orange",
                  cursor: "pointer",
                  fontSize: "55px",
                }}
              />
              <span>Attention, vous êtes dans une Zone atomique !</span>
              <span className={styles.adminName}>
                Entrez votre mot de passe pour accéder aux fonctionnalités
                protégées
              </span>
            </div>

            <div className={styles.containerInput}>
              <InputForms
                id={styles.pass1}
                placeholder="Mot de passe"
                type="password"
                onChange={(e) => setPassWordAdmin(e.target.value)}
                required={true}
              />
            </div>

            <Button
              onPress={authFunctionAtomic}
              styles="btnPrimary"
              svg={<GiOverkill />}
              text="Accéder aux fonctionnalités protégées"
            />
          </div>
        ) : (
          <div className={styles.protectedFunctions}>
            {/* KillSwitch */}
            <div className={styles.cardFunctionProtected}>
              <div className={styles.headerCard}>
                <GiMushroomCloud
                  style={{ color: "#FFA500", fontSize: "30px" }}
                />
                <span className={styles.titleCard}>KillSwitch</span>
              </div>

              <p className={styles.descriptionCard}>
                Active ou désactive instantanément l'accès principal à la
                cabine.
              </p>

              <div className={styles.toggleContainer}>
                <label className={styles.toggleLabel}>Activer</label>
                <input
                  type="checkbox"
                  onChange={(e) => setKillSwitchUpdateInDb(e.target.checked)}
                  checked={killSwitch}
                  className={styles.toggleInput}
                />
              </div>

              {hasChanged && (
                <div className={styles.containerImg}>
                  {killSwitch ? (
                    <img src="https://media.giphy.com/media/xTiIzrRyvrFijaEtY4/giphy.gif" />
                  ) : (
                    <img src="https://media.giphy.com/media/3o84sBJxpPt6g6MRdC/giphy.gif" />
                  )}
                </div>
              )}
            </div>

            {/* Suppression cabine */}
            <div className={styles.cardFunctionProtected}>
              <div className={styles.headerCard}>
                <GiMushroomCloud
                  style={{ color: "#FF4D4F", fontSize: "30px" }}
                />
                <span className={styles.titleCard}>Supprimer la cabine</span>
              </div>

              <p className={styles.descriptionCard}>
                Cette action est <strong>définitive</strong>. La cabine sera
                supprimée de la base de données. Veuillez confirmer.
              </p>

              <Button
                onPress={handleCabineDelete}
                styles={"btnDelete"}
                text="Supprimer définitivement"
              />
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default UpdateFeatures;
